import { render, staticRenderFns } from "./init_data_gsheets.vue?vue&type=template&id=685593b1"
import script from "./init_data_gsheets.vue?vue&type=script&setup=true&lang=js"
export * from "./init_data_gsheets.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports